import request from "@/axios/http";

export function getInfo (params) {

	return request({
		url: '/stage-api/lottery/technician/identity',
		method: 'get',
		params
	})

}

// 技巧师预测明细
export function techList (params) {
	return request({
		url: '/stage-api/pre/detail/tech/list',
		method: 'get',
		params
	})
}

// 技巧师近期成绩
export function techScore (params) {
	return request({
		url: '/stage-api/pre/detail/achievmentTechList',
		method: 'get',
		params,
	})
}

